module.exports = __webpack_public_path__ + "static/media/31_VTA - Silicon Valley.b20aa2f5.jpg";